<template>
    <div class="footer">
      <div class="footerMsg">
        <div class="logoBox">
          <span v-for="(item, index) in footer" :key="index">
            <a :href="item.enUrl" target="_blank">
              <img :src="item.logo" :alt="item.alt" :title="item.alt" :class="'img'+index">
            </a>
          </span>
        </div>
        <div class="copyright">
          <span>National Satellite Meteorological Center.</span>
          <span>Email: iusc_nsmc@cma.gov.cn</span>
          <!-- <span>(86) 10-6840 8737</span> -->
          <span>Copyright © NSMC. All Rights Reserved.</span>
          <span>京公网安备110108002134号 | 京ICP备09070587号</span>
        </div>
      </div>
    </div>
</template>
<script>
    export default {
        name: 'App',
        data () {
            return {
                footer: window.fyEarth.footer,
            }
        },
        methods: {

        }
    }
</script>
<style scoped>
</style>